import { render, staticRenderFns } from "./update-registration-page.vue?vue&type=template&id=63aecf6d&scoped=true&"
import script from "./update-registration-page.vue?vue&type=script&lang=js&"
export * from "./update-registration-page.vue?vue&type=script&lang=js&"
import style0 from "./update-registration-page.vue?vue&type=style&index=0&id=63aecf6d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63aecf6d",
  null
  
)

export default component.exports